import type {
  LocalPcfGroupFailure,
  LocalPcfMappingCoverageCounts,
} from './pcfExportCalculation';
import { webLog } from './webLogger';

export function createMappedHeaderWarning(
  coverage: LocalPcfMappingCoverageCounts,
  profileName?: string,
): string | null {
  const configured = coverage.projectConfigured + coverage.systemConfiguredSlots;
  const resolved = coverage.projectResolved + coverage.systemResolved;
  if (configured === 0 || resolved > 0) {
    return null;
  }

  const coverageParts: string[] = [];
  if (coverage.projectConfigured > 0) {
    coverageParts.push(
      `${coverage.projectResolved} of ${coverage.projectConfigured} project header values resolved`,
    );
  }
  if (coverage.systemConfiguredSlots > 0) {
    coverageParts.push(
      `${coverage.systemResolved} of ${coverage.systemConfiguredSlots} system header values resolved `
        + `across ${coverage.systemSources} system source${coverage.systemSources === 1 ? '' : 's'}`,
    );
  }

  const profileLabel = profileName ? `Profile "${profileName}"` : 'The selected profile';
  return `${profileLabel} mapped header values are empty in this Revit model: `
    + `${coverageParts.join('; ')}. The export continued, but generated PCF headers will be blank. `
    + 'Populate these Revit parameters (QuickFill) or update the profile mapping.';
}

export function logPcfMappingCoverage(
  traceId: string,
  coverage: LocalPcfMappingCoverageCounts,
): void {
  const message = `[mapped-parameter-coverage] traceId=${traceId} `
    + `projectResolved=${coverage.projectResolved}/${coverage.projectConfigured} `
    + `systemResolved=${coverage.systemResolved}/${coverage.systemConfiguredSlots} `
    + `systemSources=${coverage.systemSources}`;
  const incomplete = coverage.projectResolved < coverage.projectConfigured
    || coverage.systemResolved < coverage.systemConfiguredSlots;
  const logger = incomplete ? webLog.warn : webLog.info;
  logger('export-orchestrator', message);

  if (createMappedHeaderWarning(coverage) !== null) {
    webLog.warn(
      'export-orchestrator',
      `[mapped-header-values-empty] traceId=${traceId} action=continue `
        + `projectMissing=${coverage.projectConfigured - coverage.projectResolved} `
        + `systemMissing=${coverage.systemConfiguredSlots - coverage.systemResolved}`,
    );
  }
}

export function logPcfRunGroupFailures(
  traceId: string,
  failures: readonly LocalPcfGroupFailure[],
): void {
  if (failures.length === 0) {
    return;
  }
  webLog.warn(
    'export-orchestrator',
    `[pcf-run-group-failures] traceId=${traceId} total=${failures.length}`,
  );
}
